import { GoogleAuthProvider, signInWithPopup } from "firebase/auth";
import { auth } from "firebase-utils/firebase";

export const doSignInWithGoogle = async () => {
  const provider = new GoogleAuthProvider();
  const result = await signInWithPopup(auth, provider);

  return result
}

export const doSignOut = () => {
  return auth.signOut();
}
